import { render, staticRenderFns } from "./AffiliateCrgModal.vue?vue&type=template&id=096a4e8e&"
import script from "./AffiliateCrgModal.vue?vue&type=script&lang=js&"
export * from "./AffiliateCrgModal.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateCrgModal.vue?vue&type=style&index=0&id=096a4e8e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports